import { Component, inject, input } from '@angular/core';
import { MatchBreakdownGrid, MatchBreakdownRequirement } from '../models/match-breakdown.model';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SanitizerPipe } from 'src/app/shared/pipes/sanitizer.pipe';
import { RouterModule } from '@angular/router';
import { MatchBreakdownReportIconComponent } from '../match-breakdown-report-icon/match-breakdown-report-icon.component';
import { GridComponent } from 'src/app/shared/grid/grid.component';
import { GridColumnDirective } from 'src/app/shared/grid/grid-column.directive';
import { AlternativeCertificationsService } from '../alternative-certifications.service';

@Component({
    selector: 'nova-match-breakdown-grid',
    templateUrl: './match-breakdown-grid.component.html',
    styleUrls: ['./match-breakdown-grid.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        MatIconModule,
        AsyncPipe,
        SanitizerPipe,
        RouterModule,
        MatchBreakdownReportIconComponent,
        GridComponent,
        GridColumnDirective
    ]
})
export class MatchBreakdownGridComponent {
    private readonly altCertsService = inject(AlternativeCertificationsService);

    data = input<MatchBreakdownGrid>();
    isJobScreen = input<boolean>(false);
    showRequirementsOverrideIndicator = input<boolean>(false);

    shouldShowAlternativeCertifications(dataItem: MatchBreakdownRequirement): boolean {
        return this.altCertsService.shouldShowAlternativeCertifications(dataItem, this.data()?.jobId);
    }

    getAlternativesDisplayText(dataItem: MatchBreakdownRequirement): string {
        return this.altCertsService.getAlternativesDisplayText(dataItem, this.data()?.jobId);
    }
}
